import { Author, AuthorRequest, PartialAuthor, PublishedAt } from '@feature/utils';

export const technologicalTransferTypes = ['NATIONAL', 'INTERNATIONAL', 'OTHER'] as const;

export const technologicalTransferPartnerTypes = ['PRIVATE', 'PUBLIC', 'ACADEMIC', 'OTHER'] as const;

export const technologicalTransferDomains = [
  'MEDICAL',
  'PHARMACEUTICAL',
  'IT',
  'ENGINEERING',
  'SOCIAL_SCIENCES_AND_HUMANITIES',
  'OTHER',
] as const;

export const technologicalTransferResults = [
  'R1_RESEARCH',
  'R1_TESTING',
  'R1_ANALYSIS_SERVICES_PROVIDED_TO_THE_PARTNER',
  'R2_SCIENTIFIC_EXPERTISE',
  'R2_TECHNOLOGICAL_CONSULTANCY',
  'R3_PROTOTYPE',
  'R3_METHOD',
  'R3_PROCEDURE_TRANSFERRED',
  'R4_PRODUCT',
  'R4_TECHNOLOGY_USED_BY_THE_PARTNER',
  'R5_PATENT',
  'R5_PATENT_APPLICATION',
  'R5_LICENCE',
  'R6_KNOW_HOW_TRANSFERRED',
  'R0_OTHER',
] as const;

export interface TechnologicalTransfer {
  id: number;
  title: string;
  registrationNo: string;
  contractNo: string;
  partnershipAgreement: string;
  protocol: string;

  type: (typeof technologicalTransferTypes)[number];
  typeName: string | null;
  partnerType: (typeof technologicalTransferPartnerTypes)[number];
  partnerTypeName: string | null;
  domain: (typeof technologicalTransferDomains)[number];
  domainName: string | null;
  results: (typeof technologicalTransferResults)[number][];
  resultName: string | null;

  startDate: PublishedAt;
  endDate: PublishedAt;

  authors: Author[];

  createdAt: string;
}

export interface TechnologicalTransferRequest {
  title: string;
  registrationNo: string;

  authors: AuthorRequest[];
}

export interface TechnologicalTransferSearchRequest {
  title: string;
  registrationNo: string;
}

export interface ReclaimRequest {
  technologicalTransferId: number;
  authorId: number;
}

export interface ReclaimableTechnologicalTransfer {
  id: number;
  title: string;
  authors: PartialAuthor[];
}

export interface TechnologicalTransferReclaimSearch {
  technologicalTransfer: ReclaimableTechnologicalTransfer | null;
}
